module.exports = __webpack_public_path__ + "static/media/ppm.6b5a0968.JPG";